module.exports = __webpack_public_path__ + "static/media/karen1-250x251.c6a6914d.png";